export default {
    option: {
        value: 'activity',
        label: 'DoctorPlan',

        children: [
            // {
            //     value: 'active',
            //     label: 'Has been active',
            //     match: (patient) => (patient.verified && patient.activity >= Date.now() - 86400000 * 30)
            // },
            // {
            //     value: 'not-active',
            //     label: 'Has not been active',
            //     match: (patient) => (!patient.verified || patient.activity < Date.now() - 86400000 * 30)
            // },
            {
                value: 'verified',
                label: 'Has confirmed',
                match: (patient) => patient.verified
            },
            {
                value: 'not-verified',
                label: 'Has not confirmed',
                match: (patient) => !patient.verified
            },
            {
                value: 'download-app',
                label: 'Has downloaded app',
                match: (patient) => (patient.ios_version || patient.android_version)
            },
            {
                value: 'not-download-app',
                label: 'Has not downloaded app',
                match: (patient) => (!patient.ios_version && !patient.android_version)
            }
        ]
    }
}
